import React from "react";

import { HealthSummary } from "../Shared";

interface BloodOxygenSaturationData {
  date: string;
  low: number;
  high: number;
  avg: number;
}

interface HourlyBloodOxygenSaturationData {
  datetime: string;
  hour: number;
  low: number;
  high: number;
  avg: number;
}

interface BloodOxygenSaturationSummaryProps {
  filteredData: (BloodOxygenSaturationData | HourlyBloodOxygenSaturationData)[];
  metadata: {
    avg: number;
    min: number;
    max: number;
  } | null;
  handlePrevious: () => void;
  handleNext: () => void;
  onDateSelect: (date: Date) => void;
  selectedDate: Date;
  selectedRange: string;
}

export const BloodOxygenSaturationSummary: React.FC<
  BloodOxygenSaturationSummaryProps
> = ({
  filteredData,
  metadata,
  handlePrevious,
  handleNext,
  onDateSelect,
  selectedDate,
  selectedRange,
}) => {
    const getSummaryValues = (metadata: { avg: number; min: number; max: number } | null, _filteredData: (BloodOxygenSaturationData | HourlyBloodOxygenSaturationData)[]) => [
      {
        label: "Low",
        value: metadata?.min ?? 0,
        color: "#3b82f6", // blue-500
        unit: "%",
      },
      {
        label: "Avg",
        value: metadata?.avg ?? 0,
        color: "#22c55e", // green-500
        unit: "%",
      },
      {
        label: "High",
        value: metadata?.max ?? 0,
        color: "#ef4444", // red-500
        unit: "%",
      },
    ];

    return (
      <HealthSummary
        filteredData={filteredData}
        metadata={metadata}
        handlePrevious={handlePrevious}
        handleNext={handleNext}
        onDateSelect={onDateSelect}
        selectedDate={selectedDate}
        selectedRange={selectedRange}
        getSummaryValues={getSummaryValues}
      />
    );
  };